import { QueryCacheOptions } from '@fullstory/proto/fs/services/alexa';
import { Duration } from '@fullstory/proto/google/protobuf';

const hour = 60 * 60 * 1000; // 60 seconds * 60 minutes * 1000 ms

export const appCacheRefresh: QueryCacheOptions = {
  getIfAgeLessThan: Duration.fromMillis(2 * hour),
  computeIfOlderThan: Duration.fromMillis(hour),
  skipCache: false,
  queue: QueryCacheOptions.Queue.QUEUE_INVALID,
};
